export default __webpack_public_path__ + "static/media/user-level.01f8021c.svg";